:host{display:flex;flex-direction:column;gap:8px;padding:16px 8px;overflow-y:auto;overflow-x:hidden}span{color:#232426de}mat-divider{margin-bottom:16px}
/*# sourceMappingURL=view-settings2d.component.css.map */
